/** Max words for funnel free-text fields (enforced silently on change). */
export const FUNNEL_TEXT_MAX_WORDS = 50;

/**
 * Truncates after `maxWords` whitespace-delimited tokens. Leading/trailing
 * space before a blocked word is trimmed so the box doesn’t grow with spaces.
 */
export function truncateToMaxWords(s: string, maxWords: number): string {
  if (maxWords <= 0) return "";
  let wordCount = 0;
  let i = 0;
  while (i < s.length) {
    while (i < s.length && /\s/.test(s[i])) i++;
    if (i >= s.length) return s;
    wordCount++;
    if (wordCount > maxWords) return s.slice(0, i).replace(/\s+$/, "");
    while (i < s.length && !/\s/.test(s[i])) i++;
  }
  return s;
}
